import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";

export default function PartnerAuditPage() {
    const { api } = useAuth();
    const [events, setEvents] = useState([]);

    useEffect(() => {
        api.get("/v2/partner/audit").then(r => setEvents(r.data.events || [])).catch(() => {});
    }, [api]);

    return (
        <div data-testid="partner-audit-page">
            <div className="mb-8">
                <h1 className="text-3xl font-display font-bold text-white">Audit</h1>
                <p className="text-sm text-gray-500 mt-1">Append-only log of all events across your portfolio. Last 200 events.</p>
            </div>
            <div className="bg-card border border-border/40">
                <div className="grid grid-cols-[180px_1fr_1fr_2fr] px-5 py-3 border-b border-border/40 text-xs text-gray-600 font-body uppercase tracking-wider">
                    <span>Timestamp</span><span>Event</span><span>Workspace</span><span>Details</span>
                </div>
                {events.map(e => (
                    <div key={e.id} className="grid grid-cols-[180px_1fr_1fr_2fr] px-5 py-3 border-b border-border/20 items-center"
                        data-testid={`audit-row-${e.id}`}>
                        <span className="text-xs text-gray-500 font-mono">{e.timestamp ? new Date(e.timestamp).toLocaleString() : "—"}</span>
                        <span className="text-xs text-white font-mono">{e.event_type}</span>
                        <span className="text-xs text-gray-400 font-mono truncate">{e.enterprise_id?.slice(0, 8) || "—"}</span>
                        <span className="text-xs text-gray-500 font-mono truncate">
                            {Object.entries(e.details || {}).slice(0, 4).map(([k, v]) => `${k}=${typeof v === 'string' ? v.slice(0, 30) : v}`).join(" · ")}
                        </span>
                    </div>
                ))}
                {events.length === 0 && (
                    <div className="px-5 py-10 text-xs text-gray-500 text-center">No events yet.</div>
                )}
            </div>
        </div>
    );
}
